import "swiper/swiper-bundle.css";
import "glightbox/dist/css/glightbox.min.css";

import { Autoplay, EffectFade, Pagination } from "swiper/modules";

import GLightbox from "glightbox";
import SimpleParallax from "simple-parallax-js";
import Swiper from "swiper";

var images = document.querySelectorAll("section.image[data-parallax=true] img");
new SimpleParallax(images, {
	scale: 1.4,
	delay: 0,
	orientation: "down",
});

const lightbox = GLightbox();

Array.from(document.querySelectorAll("section.image .swiper")).map((hero) => {
	const swiper = new Swiper(hero, {
		modules: [Autoplay, Pagination, EffectFade],
		effect: "fade",
		fadeEffect: {
			crossFade: true,
		},
		autoplay: {
			delay: 7500,
		},
		loop: true,
	});
});
